import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { $getRoot } from 'lexical';
import { contributorAtom } from '../../../../components/Common/Form/textarea-custom-hook-form/atom';

export const useMediaNodesContributors = () => {
  const [, setContributors] = useAtom(contributorAtom);

  const handleEditorChange = useCallback(
    (editorState) => {
      editorState.read(() => {
        const root = $getRoot();

        // Function to recursively traverse all descendants
        const findMediaNodes = (node) => {
          const mediaNodes = [];
          if (node.getType() === 'image' || node.getType() === 'video') {
            mediaNodes.push(node);
          }

          if (node.getChildren) {
            const children = node.getChildren();
            children.forEach((child) => {
              mediaNodes.push(...findMediaNodes(child));
            });
          }
          return mediaNodes;
        };

        const allMediaNodes = findMediaNodes(root);
        const remainingUserIds = allMediaNodes
          .map((mediaNode) => mediaNode.getContributorId())
          .filter(Boolean);

        setContributors((prevContributors) => {
          const manualContributor = prevContributors.filter((contributor) => contributor.isManual);
          const autoContributor = prevContributors.filter(
            (contributor) => !contributor.isManual && remainingUserIds.includes(contributor.user.id)
          );

          const newContributors = [...autoContributor, ...manualContributor];
          if (JSON.stringify(prevContributors) !== JSON.stringify(newContributors)) {
            return newContributors;
          }
          // Return the previous state if no changes
          return prevContributors;
        });
      });
    },
    [setContributors]
  );

  return { handleEditorChange };
};
